import React, { useState } from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Card } from '../components/ui/card';
import { MapPin, Phone, Envelope } from '@phosphor-icons/react';
import { toast } from 'sonner';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contact() {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('name', form.name);
      formData.append('email', form.email);
      formData.append('message', form.message);

      await axios.post(`${API_URL}/contact/submit`, formData);

      toast.success('Message sent successfully!');
      setForm({ name: '', email: '', message: '' });
    } catch (error) {
      toast.error('Failed to send message');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Navigation />

      <section className="pt-32 pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-16">
            <h1 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-white mb-4" data-testid="contact-heading">
              Contact Us
            </h1>
            <p className="text-lg text-slate-400">
              Have questions? We're here to help.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <Card className="p-8 bg-card border-border">
              <h2 className="font-heading text-2xl font-medium text-white mb-6">Send Message</h2>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <Label htmlFor="name">Name *</Label>
                  <Input
                    id="name"
                    value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                    required
                    data-testid="contact-name-input"
                    className="border-bold"
                  />
                </div>

                <div>
                  <Label htmlFor="email">Email *</Label>
                  <Input
                    id="email"
                    type="email"
                    value={form.email}
                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                    required
                    data-testid="contact-email-input"
                    className="border-bold"
                  />
                </div>

                <div>
                  <Label htmlFor="message">Message *</Label>
                  <Textarea
                    id="message"
                    rows={6}
                    value={form.message}
                    onChange={(e) => setForm({ ...form, message: e.target.value })}
                    required
                    data-testid="contact-message-input"
                    className="border-bold"
                  />
                </div>

                <Button
                  type="submit"
                  className="w-full bg-[#0066FF] hover:bg-[#0052CC]"
                  disabled={loading}
                  data-testid="contact-submit-button"
                >
                  {loading ? 'Sending...' : 'Send Message'}
                </Button>
              </form>
            </Card>

            <div className="space-y-8">
              <Card className="p-6 bg-card border-border">
                <div className="flex items-start">
                  <div className="p-3 rounded-lg bg-[#0066FF]/10 border border-[#0066FF]/20 mr-4">
                    <Envelope size={24} className="text-[#0066FF]" />
                  </div>
                  <div>
                    <h3 className="font-heading text-lg font-medium text-white mb-1">Email</h3>
                    <p className="text-slate-400">contact@crystallintelligence.com</p>
                  </div>
                </div>
              </Card>

              <Card className="p-6 bg-card border-border">
                <div className="flex items-start">
                  <div className="p-3 rounded-lg bg-[#0066FF]/10 border border-[#0066FF]/20 mr-4">
                    <MapPin size={24} className="text-[#0066FF]" />
                  </div>
                  <div>
                    <h3 className="font-heading text-lg font-medium text-white mb-1">Office</h3>
                    <p className="text-slate-400">
                      1211 SE 5th Avenue<br />
                      Crystal River, FL 34429
                    </p>
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
